import React, { useState } from 'react'
import TopBar from 'components/Topbar'
import './index.scss'

const FAQ_DATA = [
  {
    question: "Jak mogę dodać wirtualny profil?",
    answer: "Wybierz z dolnej belki w aplikacji czarny przycisk z symbolem plusa, następnie: 'Dodaj profil' i przejdź przez formularz.",
  },
  {
    question: "Jak usunąć wirtualny profil?",
    answer: "Wybierz profil, który chcesz usunąć, wejdź w panel zarządzania, wybierz ikonę ustawień i kliknij 'Usuń profil'",
  },
  {
    question: "Jak usunąć moje konto z aplikacji?",
    answer: "Zaloguj się w aplikacji, następnie wybierz z wysuwanego menu z prawej strony przycisk 'Ustawienia' następnie wciśnij: 'Usuń konto' lub skontaktuj się naszym działem obsługi klienta na pomoc@mojekondolencje.pl. W wyniku usunięcia konta, zostaną również usunięte założone Wirtualne Profile, a posiadane Tabliczki przestaną działać."
  },
]

const Help = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(window.location.search.includes('deleteAccount') ? 2 : null)

  const toggleFAQ = (index: number) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index))
  }

  return (
    <div className='help'>
      <TopBar isSticky theme='dark' title='Pomoc' />
      <div className="help__content">
        <h2>FAQ <br></br>Najczęściej zadawane pytania</h2>
        <div className="faq">
          {FAQ_DATA.map((item, index) => (
            <div key={index} className="faq-item">
              <div
                className="faq-title"
                onClick={() => toggleFAQ(index)}>
                {item.question}
                <i className={`icon ${activeIndex === index ? 'icon--arrow-chev-up s24' : 'icon--arrow-chev-down s24'}`}></i>
              </div>
              <div
                className={`faq-content ${activeIndex === index ? 'open' : ''}`}
                style={{ maxHeight: activeIndex === index ? '300px' : '0' }}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
        <h2>Nie znalazłeś odpowiedzi?<br></br>Skontaktuj się z nami</h2>
        <div className="contact">
          <div className="item">
            <i className="icon icon--mail s24"></i>
            <span>pomoc@mojekondolencje.pl</span>
          </div>
          <div className="item">
            <i className="icon icon--call s24"></i>
            <span>+48 502 657 566</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Help
